import { Col, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import DashboardCard from "../DashboardCard";

const StrategicPlanCards = () => {
  const { dashboardData: data } = useSelector((state) => state.dashboardState);

  console.log({ data: data });
  return (
    <Row gutter={[4, 2]}>
      <Col md={12} sm={24} xs={24}>
        <DashboardCard
          title="Beneficiaries Reached:"
          value={
            <>
              <p className="fw-normal">
                TOTAL PEOPLE:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.totalPeople || 0}{" "}
                </span>
              </p>
              <p className="fw-normal">
                MALE:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.maleTotal || 0}
                </span>{" "}
              </p>
              <p className="fw-normal">
                FEMALE:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.femaleTotal || 0}
                </span>{" "}
              </p>
              <p className="fw-normal">
                ABOVE 18:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.ageTotal?.above18 || 0}
                </span>{" "}
                BELOW 18:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.ageTotal?.below18 || 0}
                </span>{" "}
              </p>
              <p className="fw-normal">
                DISABLED MALE:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.disabilityTotals?.male || 0}
                </span>{" "}
              </p>
            </>
          }
        />
      </Col>
      <Col md={12} sm={24} xs={24}>
        <DashboardCard
          title="Institutions Supported"
          value={
            <>
              <p className="fw-normal">
                SCHOOLS:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.institutionsSupported
                    ?.totalSchools || 0}
                </span>{" "}
              </p>
              <p className="fw-normal">
                HOUSE HOLDS:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.institutionsSupported
                    ?.totalHouseHolds || 0}
                </span>{" "}
              </p>
              <p className="fw-normal">
                GROUPS:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.institutionsSupported?.groups || 0}
                </span>{" "}
              </p>
              <p className="fw-normal mb-4 pb-4">
                HEALTH FACILITIES:{" "}
                <span className="fw-bold text-primary">
                  {data?.strategicPlanData?.institutionsSupported
                    ?.totalHealthFacilities || 0}
                </span>{" "}
              </p>
            </>
          }
        />
      </Col>
      <Col md={12} sm={24} xs={24} lg={24}>
        <DashboardCard
          title="Action Points Tracking"
          value={
            <>
              <p className="fw-normal text-danger">
                PENDING:{" "}
                <span className="fw-bold text-primary">
                  {data?.actionPoints?.totalPendingActionPoints || 0}
                </span>{" "}
              </p>
              <p className="fw-normal text-warning">
                WORK IN PROGRESS:{" "}
                <span className="fw-bold text-primary">
                  {data?.actionPoints?.totalWorkInProgressActionPoints || 0}
                </span>{" "}
              </p>
              <p className="fw-normal text-success">
                COMPLETED:{" "}
                <span className="fw-bold text-primary">
                  {data?.actionPoints?.totalCompletedActionPoints || 0}
                </span>{" "}
              </p>
            </>
          }
        />
      </Col>
    </Row>
  );
};

export default StrategicPlanCards;
